<template>
  <div>
    <a-form-modelCols
      v-model="data"
      class="pb-1 mx-1 mt-1"
      :model="getFormModel(['text', 'images'])"
      :values="data"
      :errors="errors"
      :config="{ dense: true, readonly, hideDetails: true }"
      @validate="
        $emit('change');
        submit(true);
      "
    />
  </div>
</template>

<script>
import { getForm, getAccess, libChecks, submitForm } from "@/components/mixings";
export default {
  name: "a-b",
  mixins: [getForm, libChecks, getAccess, submitForm],
  props: {
    value: Object,
    config: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    readonly: { type: Boolean, default: false },
    object: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    model() {
      let res = [
        { name: "text", title: "Текст вопроса", type: "ckeditor5", rows: 3, validator: ["req"] },
        { name: "images", type: "images", video: false, validator: ["req"] },
      ];
      return res;
    },
  },
  created() {
    this.updateData();
  },
  watch: {
    value(v) {
      this.updateData();
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      let data = this.value;
      if (!data) this.isChanged = true;
      for (const name in data) {
        this.$set(this.data, name, data[name]);
        this.$set(this.errors, name, null);
      }
      this.loading = false;

      this.afterFetchData(data);
    },
    async post(data, api, silent = false) {
      this.loading = true;
      try {
        this.loading = false;
        this.$emit("commit", data);
        this.afterSave(data);
      } catch (error) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при сохранении",
        });
        this.loading = false;
        return;
      }
    },
    commit() {
      this.$emit("input", this.list);
    },
    onClickDel(key) {
      let e = this.list;
      e.splice(key, 1);
      e.forEach((el, i) => {
        el.numb = i + 1;
      });
      this.list = e;
      this.commit();
      this.reset();
      if (this.curError?.id == key) {
        this.curError = {};
      }
    },
  },
};
</script>
